/* tslint:disable:max-line-length */
import { DefaultMessages, RequestOrganizationMessages } from '@sheerid/jslib';

type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

type ThisProjectMessages = {
    locales: {
        en: string, // need to support `en` in additon to `en-US` for ADSK's requirements
        is: string, // need to support `is` for ADSK's requirements
        ro: string, // need to support `ro` for ADSK's requirements
    },
    countries: {
        CD: string, // the jslib doesn't include a country code for Democratic Republic of Congo
        CZ: string, // the jslib uses the incorrect country code for Czech Republic
        PS: string, // the jslib doesn't include a country code for Palestine
        SS: string, // the jslib doesn't include a country code for South Sudan
        TL: string, // the jslib doesn't include a country code for Timor-Leste
    },
};


type LibraryMessages = DefaultMessages & RequestOrganizationMessages;

export const zhRequestOrgMessages: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    title: '添加學校申請',
    description: '請填妥以下表格。我們不保證會添加已提交申請的學校，但所有申請將由SheerID評估及審批。',
    noCountry: '找不到你的學校的所在國家？你不合資格選用此優惠',
    searchByOrgName: '找不到你的學校？按名字檢索',
    completeRequest: '在合資格或不合資格學校清單中找不到你的學校？完成你的申請',
    submit: '提交',
    eligibleOrgs: '合資格學校。點擊圖示以複製名字再回到驗証表格',
    ineligibleOrgs: '不合資格學校。很抱歉，此等學校的學生不合資格使用此優惠',
    none: '無',
    country: '你就讀哪所學校？',
    changeLanguage: '更改语言',
    copied: '复制',
    firstName: '名字',
    lastName: '姓',
    emailAddress: '电子邮件地址',
    poweredBy: '驗証服務由SheerID提供',
    fields: {
        countryPlaceholder: '選擇國家',
        domainLabel: '學校網頁',
        domainPlaceholder: 'www.我的學校.cn',
        orgNameLabel: '學校名稱',
        orgNamePlaceholder: '我的學校',
    },
    step: {
        success: {
            title: '致谢',
            description: '我们已收到您添加教育机构的请求。请注意，研究您的请求最多需要 7 天的时间，不保证一定会将您请求的机构添加到具有 Autodesk 产品教育访问权限的合格教育机构列表。同时，您可以选择探索其他固定期限使用许可选项。',
        },
        error: {
            title: '發生錯誤',
            description: '很抱歉，我們未能處理你的申請。請稍後再試。',
            seeingProblem: '如果多次出現此問題',
            contactUs: '請與我們聯絡',
        },
    },
    errorId: {
        invalidCountry: '必填',
        invalidEmail: '電郵地址不正確',
        invalidFirstName: '名字不正確',
        invalidLastName: '姓氏不正確',
        requiredField: '必填',
        invalidField: '資料不正確',
        invalidUrl: '網址不正確',
        tooManyResults: '出現太多檢索結果，請調整檢索要求並再次嘗試',
    },
    faq: 'SheerID添加學校申請常見問題',
    countries: {
        AD: ' 安道尔',
        AE: '阿联酋',
        AF: '阿富汗',
        AG: '安提瓜和巴布达',
        AI: '安圭拉',
        AL: '阿尔巴尼亚',
        AM: '亚美尼亚',
        AN: '荷属安的列斯群岛',
        AO: '安哥拉',
        AR: '阿根廷',
        AS: '美属萨摩亚',
        AT: '奥地利',
        AU: '澳大利亚',
        AW: '阿鲁巴',
        AZ: '阿塞拜疆',
        BA: '波黑',
        BB: '巴巴多斯',
        BD: '孟加拉',
        BE: '比利时',
        BF: '布基纳法索',
        BG: '保加利亚',
        BH: '巴林',
        BI: '布隆迪',
        BJ: '贝宁',
        BM: '百慕大',
        BN: '文莱',
        BO: '玻利维亚',
        BR: '巴西',
        BS: '巴哈马',
        BT: '不丹',
        BV: '布维岛',
        BW: '博茨瓦纳',
        BY: '白俄罗斯',
        BZ: '伯利兹',
        CA: '加拿大',
        CD: '刚果民主共和国',
        CF: '中非共和国',
        CG: '刚果',
        CH: '瑞士',
        CI: '象牙海岸（科特迪瓦）',
        CK: '库克群岛',
        CL: '智利',
        CM: '喀麦隆',
        CN: '中国',
        CO: '哥伦比亚',
        CR: '哥斯达黎加',
        CU: '古巴',
        CV: '佛得角',
        CY: '塞浦路斯',
        CZ: '捷克共和国',
        DE: '德国',
        DJ: '吉布提',
        DK: '丹麦',
        DM: '多米尼克',
        DO: '多米尼加共和国',
        DZ: '阿尔及利亚',
        EC: '厄瓜多尔',
        EE: '爱沙尼亚',
        EG: '埃及',
        EH: '西撒哈拉',
        ER: '厄立特里亚',
        ES: '西班牙',
        ET: '埃塞俄比亚',
        FI: '芬兰',
        FJ: '斐济',
        FK: '福克兰群岛',
        FM: '密克罗尼西亚',
        FO: '法罗群岛',
        FR: '法国',
        GA: '加蓬',
        GB: '英国',
        GD: '格林纳达',
        GE: '格鲁吉亚',
        GF: '法属圭亚那',
        GH: '加纳',
        GI: '直布罗陀',
        GL: '格陵兰岛',
        GM: '冈比亚',
        GN: '几内亚',
        GP: '瓜德罗普（法语）',
        GQ: '赤道几内亚',
        GR: '希腊',
        GS: '南乔治亚岛和南桑威奇群岛',
        GT: '危地马拉',
        GU: '关岛（美国）',
        GW: '几内亚比绍',
        GY: '圭亚那',
        HK: '香港',
        HM: '赫德岛和麦克唐纳群岛',
        HN: '洪都拉斯',
        HR: '克罗地亚',
        HT: '海地',
        HU: '匈牙利',
        ID: '印度尼西亚',
        IE: '爱尔兰',
        IL: '以色列',
        IN: '印度',
        IO: '英属印度洋领地',
        IQ: '伊拉克',
        IR: '伊朗',
        IS: '冰岛',
        IT: '意大利',
        JM: '牙买加',
        JO: '约旦',
        JP: '日本',
        KE: '肯尼亚',
        KG: '吉尔吉斯斯坦',
        KH: '柬埔寨',
        KI: '基里巴斯',
        KM: '科摩罗',
        KN: '圣基茨和尼维斯安圭拉',
        KP: '朝鲜',
        KR: '韩国',
        KW: '科威特',
        KY: '英属开曼群岛',
        KZ: '哈萨克斯坦',
        LA: '老挝',
        LB: '黎巴嫩',
        LC: '圣卢西亚',
        LI: '列支敦士登',
        LK: '斯里兰卡',
        LR: '利比里亚',
        LS: '莱索托',
        LT: '立陶宛',
        LU: '卢森堡',
        LV: '拉脱维亚',
        LY: '利比亚',
        MA: '摩洛哥',
        MC: '摩纳哥',
        MD: '摩尔达维亚',
        ME: '黑山',
        MG: '马达加斯加',
        MH: '马绍尔群岛',
        MK: '马其顿',
        ML: '马里',
        MM: '缅甸',
        MN: '蒙古',
        MO: '澳门',
        MP: '北马里亚纳群岛',
        MQ: '马提尼克（法语）',
        MR: '毛里塔尼亚',
        MS: '蒙特塞拉特岛',
        MT: '马耳他',
        MU: '毛里求斯',
        MV: '马尔代夫',
        MW: '马拉维',
        MX: '墨西哥',
        MY: '马来西亚',
        MZ: '莫桑比克',
        NA: '纳米比亚',
        NC: '新喀里多尼亚（法语）',
        NE: '尼日尔',
        NF: '诺福克岛',
        NG: '尼日利亚',
        NI: '尼加拉瓜',
        NL: '荷兰',
        NO: '挪威',
        NP: '尼泊尔',
        NR: '瑙鲁',
        NU: '纽埃',
        NZ: '新西兰',
        OM: '阿曼',
        PA: '巴拿马',
        PE: '秘鲁',
        PF: '波利尼西亚（法语）',
        PG: '巴布亚新几内亚',
        PH: '菲律宾',
        PK: '巴基斯坦',
        PL: '波兰',
        PM: '圣皮埃尔和密克隆',
        PN: '皮特克恩岛',
        PR: '波多黎各',
        PS: '巴勒斯坦',
        PT: '葡萄牙',
        PW: '帕劳',
        PY: '巴拉圭',
        QA: '卡塔尔',
        RE: '留尼汪（法语）',
        RO: '罗马尼亚',
        RS: '塞尔维亚',
        RU: '俄罗斯联邦',
        RW: '卢旺达',
        SA: '沙特阿拉伯',
        SB: '所罗门群岛',
        SC: '塞舌尔',
        SD: '苏丹',
        SE: '瑞典',
        SG: '新加坡',
        SH: '圣赫勒拿岛',
        SI: '斯洛文尼亚',
        SK: '斯洛伐克共和国',
        SL: '塞拉利昂',
        SM: '圣马力诺',
        SN: '塞内加尔',
        SO: '索马里',
        SR: '苏里南',
        SS: '南苏丹',
        ST: '圣多美和普林西比',
        SV: '萨尔瓦多',
        SY: '叙利亚',
        SZ: '斯威士兰',
        TC: '特克斯和凯科斯群岛',
        TD: '乍得',
        TF: '法属南部领地',
        TG: '多哥',
        TH: '泰国',
        TJ: '塔吉克斯坦',
        TK: '托克劳群岛',
        TL: '东帝汶',
        TM: '土库曼斯坦',
        TN: '突尼斯',
        TO: '汤加',
        TR: '土耳其',
        TT: '特立尼达和多巴哥',
        TV: '图瓦卢',
        TW: '台湾',
        TZ: '坦桑尼亚',
        UA: '乌克兰',
        UG: '乌干达',
        UM: '美国本土外小岛屿',
        US: '美国',
        UY: '乌拉圭',
        UZ: '乌兹别克斯坦',
        VA: '梵蒂冈',
        VC: '圣文森特和格林纳丁斯',
        VE: '委内瑞拉',
        VG: '维尔京群岛（英国）',
        VI: '维尔京群岛（美国）',
        VN: '越南',
        VU: '瓦努阿图',
        WF: '瓦利斯和富图纳群岛',
        WS: '萨摩亚',
        XK: '科索沃',
        YE: '也门',
        YT: '马约特',
        ZA: '南非',
        ZM: '赞比亚',
        ZW: '津巴布韦',
        },
    locales: {
        ar: ' 阿拉伯语',
        bg: '保加利亚语',
        cs: '捷克语',
        da: '丹麦语',
        de: '德语',
        el: '希腊语',
        'en-GB': '英语（英国）',
        'en-US': '英语',
        'es-ES': '西班牙语（西班牙）',
        es: '西班牙语',
        fi: '芬兰语',
        'fr-CA': '法语（加拿大）',
        fr: '法语',
        hr: '克罗地亚语',
        hu: '匈牙利语',
        id: '印度尼西亚语',
        is: '冰岛语',
        it: '意大利语',
        iw: '希伯来语',
        ja: '日语',
        ko: '韩语',
        lt: '立陶宛语',
        ms: '马来语',
        nl: '荷兰语',
        no: '挪威语',
        pl: '波兰语',
        'pt-BR': '葡萄牙语（巴西）',
        pt: '葡萄牙语',
        ro: '罗马尼亚语',
        ru: '俄罗斯',
        sk: '斯洛伐克语',
        sl: '斯洛文尼亚语',
        sr: '塞尔维亚语',
        sv: '瑞典语',
        tr: '土耳其语',
        'zh-HK': '中文（香港）',
        zh: '中文（繁体）',
    },
};
